import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BlogService } from '../blog.service';
import { BlogContent } from '../types/blog-content.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';
import { MetafrenzyService } from 'ngx-metafrenzy';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.scss']
})
export class BlogListComponent implements OnInit, OnDestroy {
  blogContent: BlogContent[] = [];
  loading = true;

  private unsubscribeAll: Subject<any>;
  constructor(
    public blogService: BlogService,
    private loggingService: LoggingService,
    private readonly metafrenzyService: MetafrenzyService
  ) {
    this.blogTitle = $localize`:@@blogTitle:Wipperoz blog, the Wipperoz' blog`;
    this.blogSubtitle = $localize`:@@blogSubTitle:Digital content just for you; helpful tips, best life hacks and creative ideas to inspire you.`;
    this.metafrenzyService.setTitle(
      $localize`:@@metadataBlogTitle:Wipperoz's blog where you will find all sorts of resourceful articles`
    );
    this.metafrenzyService.setMetaTag(
      'description',
      $localize`:@@metadataBlogDescription:Digital content just for you; helpful tips, best life hacks and creative ideas to inspire you`
    );
    this.unsubscribeAll = new Subject();
  }

  set blogTitle(value: string) {
    this.blogService.blogTitle = value;
  }

  set blogSubtitle(value: string) {
    this.blogService.blogSubtitle = value;
  }

  ngOnInit(): void {
    this.blogService.onResultsChanged.pipe(takeUntil(this.unsubscribeAll)).subscribe(
      (data) => {
        if (data !== null) {
          this.blogContent = data;
          this.loading = false;
        }
      },
      (err) => {
        this.loading = false;
        this.loggingService.logError('Error getting blog content', JSON.stringify(err));
      }
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }

  get numbers(): number[] {
    const limit = Math.ceil(this.blogService.totalCount / this.blogService.options.pageSize);
    return Array.from({ length: limit }, (_, i) => i + 1);
  }

  next() {
    this.blogService.options.page++;
    this.blogService.getBlogContent(this.blogService.options);
  }

  prev() {
    this.blogService.options.page--;
    this.blogService.getBlogContent(this.blogService.options);
  }

  to(page: number) {
    this.blogService.options.page = page;
    this.blogService.getBlogContent(this.blogService.options);
  }
}
